module.exports = __webpack_public_path__ + "static/media/auto-renewal.23a49abb.svg";